module.exports = __webpack_public_path__ + "static/media/Logo.a826dfa2.png";